// extracted by mini-css-extract-plugin
module.exports = {"card":"sidebar-cta_card__mYf0V","h3":"sidebar-cta_h3__0SlBn","image":"sidebar-cta_image__L4_Hj","button":"sidebar-cta_button__PgM0o"};